import React from 'react';
import { stockOf } from './stockType';

/**
 * 스탁 분류 배지 — M(Master) / W(Working) / A(ARB)
 *
 * CSS 모듈이 컴포넌트별로 나뉘어 있어 인라인 스타일로 만들었다.
 * 어느 화면에 넣어도 스타일 추가 없이 동작한다.
 *
 *   <StockBadge value={item.Master} />
 *   <StockBadge value="2" size={22} />
 */
export default function StockBadge({ value, size = 20, title }) {
    const s = stockOf(value);
    return (
        <span
            title={title || s.full}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size,
                height: size,
                borderRadius: 4,
                background: s.color,
                color: '#fff',
                fontSize: Math.round(size * 0.6),
                fontWeight: 700,
                lineHeight: 1,
                letterSpacing: 0,
                flex: '0 0 auto',
                userSelect: 'none',
            }}
        >
            {s.code}
        </span>
    );
}
